module.exports = __webpack_public_path__ + "img/header.1e0c3e59.png";